<!-- 技术求购发布 -->
<template>
  <div class="container">
    <h1>基础信息</h1>
    <div class="describe">
      <p>技术详情描述</p>
      <el-input
        type="textarea"
        :rows="2"
        placeholder="请输入"
        v-model="form.description"
        resize="none"
      >
      </el-input>
    </div>
    <div class="submit" @click="submitForm">提交</div>
  </div>
</template>

<script>
import {
  getPublishPatentWantToBuy,
  getMyPatentWantToBuyDetail,
  getUpdatePatentWantToBuy,
} from "../../api/userApi";

export default {
  data() {
    return {
      isEdit: false, // 是否是编辑模式
      editId: "", // 编辑的ID
      form: {
        id: "", // 专利ID
        description: "", // 专利详情描述
      },
    };
  },
  created() {
    // 检查是否是编辑模式
    if (this.$route.query.id) {
      this.isEdit = true;
      this.editId = this.$route.query.id;
      this.fetchDetailData();
    }
  },
  methods: {
    // 获取详情数据
    async fetchDetailData() {
      try {
        const res = await getMyPatentWantToBuyDetail({ id: this.editId });

        if (res.code === 1) {
          this.form = {
            id: res.data.id,
            description: res.data.description,
          };
        } else {
          this.$message.error(res.message || "获取详情失败");
        }
      } catch (error) {
        console.error("获取详情失败:", error);
        this.$message.error("获取详情失败，请稍后重试");
      }
    },

    async submitForm() {
      // 验证必填字段
      if (!this.form.description.trim()) {
        this.$message.error("请输入技术详情描述");
        return;
      }

      try {
        // 创建FormData对象
        const formData = new FormData();
        formData.append("description", this.form.description);
        let res;
        if (this.isEdit) {
          // 编辑模式
          formData.append("id", this.form.id);
          res = await getUpdatePatentWantToBuy(formData);
        } else {
          // 新增模式
          res = await getPublishPatentWantToBuy(formData);
        }
        if (res.code === 1) {
          this.$message.success(
            res.msg || (this.isEdit ? "修改成功" : "发布成功")
          );
          this.resetForm();
          // 如果是编辑模式，返回列表页
          if (this.isEdit) {
            this.$router.push("/memberCenter/my-publications");
          }
        } else {
          this.$message.error(
            res.msg || (this.isEdit ? "修改失败" : "发布失败")
          );
        }
      } catch (error) {
        console.error("提交失败:", error);
        this.$message.error("提交失败，请稍后重试");
      }
    },

    resetForm() {
      this.form.description = "";
    },
  },
};
</script>

<style scoped lang="less">
.container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  // align-items: center;
  padding: 20px 35px 56px 20px;
  h1 {
    font-family: PingFang SC, PingFang SC;
    font-weight: 600;
    font-size: 20px;
    color: #434343;
    text-align: left;
  }
  .describe {
    margin-top: 32px;
    margin-left: 15px;
    border-bottom: 1px solid #dedede;
    padding-bottom: 32px;
    p {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 16px;
      color: #434343;
      text-align: left;
      margin-bottom: 15px;
    }
    ::v-deep .el-textarea__inner {
      width: 973px;
      height: 83px;
      background: #ffffff;
      border-radius: 4px 4px 4px 4px;
      border: 1px solid #d8d9dc;
      padding: 11px 13px;
    }
    .el-textarea__inner::placeholder {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #b1b1b1;
    }
  }
  .submit {
    width: 83px;
    height: 42px;
    background: #233cac;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    border-radius: 5px;
    font-size: 16px;
    color: #ffffff;
    line-height: 42px;
    margin-left: 15px;
    margin-top: 444px;
    cursor: pointer;
  }
}
</style>
